import { render, staticRenderFns } from "./smallLogin.vue?vue&type=template&id=8ce06320"
import script from "./smallLogin.vue?vue&type=script&lang=js"
export * from "./smallLogin.vue?vue&type=script&lang=js"
import style0 from "./smallLogin.vue?vue&type=style&index=0&id=8ce06320&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports